export enum MANAGE_TEACHING_ORDER_COMPONENT {
  EditStartDate = 'ManageSchoolStartDate',
  ManageNonTeachingDays = 'ManageNonTeachingDays',
  ManageTeachingOrders = 'ManageTeachingOrders'
}
